import ConfirmModal from '@components/modal/ConfirmModal';
import { useHistory } from 'react-router-dom';
import useDeleteChallengeGroup from './hooks/useDeleteChallengeGroup';

const DeleteChallengeGroupModal = ({ id }: DeleteChallengeGroupProps) => {
    const history = useHistory();

    const { challengeGroup, handleSubmit, isDeleting, deleteError } = useDeleteChallengeGroup(id);

    return (
        <ConfirmModal
            title="Delete ChallengeGroup"
            description={`Are you sure you want to delete the group '${challengeGroup.name}'?`}
            closeModal={() => history.replace(`/challenge-groups`)}
            handleSubmit={handleSubmit}
            isPosting={isDeleting}
            error={deleteError}
        />
    );
};

interface DeleteChallengeGroupProps {
    id: number;
}

export default DeleteChallengeGroupModal;
